import { render, staticRenderFns } from "./responsibleServicesByWeek.vue?vue&type=template&id=422b7525&scoped=true"
import script from "./responsibleServicesByWeek.vue?vue&type=script&lang=js"
export * from "./responsibleServicesByWeek.vue?vue&type=script&lang=js"
import style0 from "./responsibleServicesByWeek.vue?vue&type=style&index=0&id=422b7525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b7525",
  null
  
)

export default component.exports